// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + ({"12":"profiler","777":"recorder"}[chunkId] || chunkId) + "." + {"12":"662bfd5c","453":"3529fa71","777":"4923d0fc"}[chunkId] + ".chunk.js";
};